export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				wrapper: 'default',
				bodyWrapper: 'default'
			},
			sidebar_setting: 'default-sidebar',
			sidebar_backround: 'dark-sidebar'
		},
		color: {
			layout_version: 'light',
			color: 'color-1',
			color_waite:'#fff',
			primary_color: '#4466f2',
			secondary_color: '#1ea6ec',
			success_color:'rgb(46, 202, 106)',
			info_color:'rgb(255, 119, 29)',
			mix_layout: 'default'
		},
		// backgroundColor: {
		// 	layout_version: 'light',
		// 	primary_color: '#4466f2',
		// 	secondary_color: '#1ea6ec',
		// 	success_color:'rgb(46, 202, 106)',
		// 	info_color:'rgb(255, 119, 29)',
		// 	mix_layout: 'default'
		// },
		router_animation: 'fadeIn'
	}
}

export default ConfigDB;